import React from "react";
import { Button } from "@vitalsource/vstui";
import { XSmall } from "@vitalsource/vstui-icons";
import styled, { withTheme } from "styled-components";
import SlideOut from "./slide-out";

const LabsSurvey = styled.div`
  position: relative;
  padding: 20px 20px 28px 20px;
  background-color: ${props => props.theme.color.base.getShade(8)};

  #labs-survey-splash {
    background-color: transparent;
    position: absolute;
    width: 100%;
    height: 77px;
    z-index: 1;
    bottom: 0;
    left: 0;

    &:before {
      position: absolute;
      top: 0;
      left: 0;
      transform-origin: bottom left;
      transform: skew(103deg);
      background-color: ${props => props.theme.color.base.getShade(7)};
      width: 100%;
      height: 100%;
      content: "";
    }
  }

  width: 100%;
  height: 165px;
  color: ${props => props.theme.vstui.color.white};
  transition: transform 500ms ease-in-out;
  transform-origin: 0 0;
  overflow: hidden;
  img {
    position: absolute;
    right: 9px;
    bottom: 7px;
  }
`;

const Dismiss = styled(Button)`
  position: absolute;
  top: 0;
  right: 0;
`;

const Content = styled.div`
  height: 100%;
  width: 60%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  * {
    z-index: 2;
  }
  h3 {
    font-weight: 500;
    font-size: 2rem;
    line-height: 2.4rem;
    /* without this width: 100%, IE11 doesn't respect the bounds of the parent */
    width: 100%;
  }
  p {
    margin: 4px 0 12px 0;
    /* without this width: 100%, IE11 doesn't respect the bounds of the parent */
    width: 100%;
  }
`;

class Survey extends React.PureComponent {
  constructor() {
    super();
    this.state = { shouldShowSurvey: this.shouldShowSurvey() };
  }
  shouldShowSurvey() {
    if (Fraction.Brand.Feedback.labs_survey) {
      const lastSeen =
        Fraction.Helpers.Users.getUserData("dismissedLabsSurveyBSOCore") ||
        false;
      const currentDate = new Date().getTime();
      // If it's been at least three days since clicked or dismissed
      if (!lastSeen || currentDate - 259200000 > lastSeen) {
        return true;
      }
    }
    return false;
  }
  dismiss = () => {
    Fraction.Helpers.Users.saveUserData(
      "dismissedLabsSurveyBSOCore",
      new Date().getTime()
    );

    this.setState({ shouldShowSurvey: this.shouldShowSurvey() });
  };
  renderSurveyContent() {
    return (
      <Content>
        <h3>{i18n.t("labs.make-an-impact")}</h3>
        <Dismiss
          color="white"
          iconStart={<XSmall />}
          label={i18n.t("labs.dismiss-survey")}
          naked
          onClick={this.dismiss}
        />
        <p>{i18n.t("labs.shape-the-future")}</p>
        <Button
          color="white"
          size="small"
          id="take-survey-button"
          colorBehindButton={this.props.theme.color.base.getShade(8)}
          href="https://www.surveymonkey.com/r/BSO2021"
          target="_blank"
        >
          {i18n.t("base.learn-more")}
        </Button>
        <img role="presentation" src="/img/labs_ad.svg" alt="Labs Survey" />
      </Content>
    );
  }
  renderSurveyResultsContent() {
    return (
      <Content>
        <h3>{i18n.t("labs.thanks-for-your-feedback")}</h3>
        <p>{i18n.t("labs.we-heard-you")}</p>
        <Dismiss
          color="white"
          iconStart={<XSmall />}
          label={i18n.t("labs.dismiss-survey")}
          naked
          onClick={this.dismiss}
        />
        <img
          role="presentation"
          src="/img/thanks_graphic.svg"
          alt="Labs Results"
        />
      </Content>
    );
  }
  render() {
    return (
      <SlideOut inProp={this.state.shouldShowSurvey} height={165}>
        <LabsSurvey>
          <div id="labs-survey-splash" />
          {this.renderSurveyContent()}
        </LabsSurvey>
      </SlideOut>
    );
  }
}

export default withTheme(Survey);
